import type { CharacterBundle } from './types';

const ROOT = '/assets/textures/characters/sparky_bot';

export const SPARKY_BOT: CharacterBundle = {
  config: {
    id: 'sparky_bot',
    name: 'SPARKY',
    stats: { health: 5, strength: 5, agility: 5, luck: 5 },
    skillIds: ['sparky_bunker', 'cannon', 'earthshake', 'charge', 'repair', 'blink'],
  },
  assets: {
    idle: { url: `${ROOT}/idle/idle_v2.png`, cols: 4, rows: 4 },
    block: { url: `${ROOT}/block/bunker_v2.png`, cols: 4, rows: 4 },
    run: { url: `${ROOT}/run/run.png`, cols: 4, rows: 4 },
    // Two default attacks for variety. punch = hand (baseline), kick = leg
    // (heavier, rarer - see KICK_* constants). Engine picks which per swing.
    punch: { url: `${ROOT}/attack/punch_v2.png`, cols: 4, rows: 4 },
    kick: { url: `${ROOT}/attack/kick_v2.png`, cols: 4, rows: 4 },
    pain: { url: `${ROOT}/pain/pain.png`, cols: 4, rows: 4 },
    // Knock-up reaction (launching hits). Placeholder = pain-big sheet; repoint
    // when a dedicated pain-air sheet exists.
    painAir: { url: `${ROOT}/pain/pain-air_v2.png`, cols: 4, rows: 4 },
    dodge: { url: `${ROOT}/dodge/dodge.png`, cols: 4, rows: 4 },
    victory: { url: `${ROOT}/victory/victory.png`, cols: 4, rows: 4 },
    lose: { url: `${ROOT}/lose/lose-pose.png`, cols: 4, rows: 4 },
  },
  sfx: {
    // punch: impact thud, attacker plays it at the swing's impact frame (skip
    // on dodge). kick: swing/charge sound, attacker plays it from the first
    // frame regardless of dodge. painAir: launch reaction, the DEFENDER plays
    // it when knocked up. painAir clip is a placeholder (reuses pain) until a
    // dedicated launch sfx is added.
    punch: `${ROOT}/pain/pain.mp3`,
    kick: `${ROOT}/attack/charge-kick.mp3`,
    painAir: `${ROOT}/pain/pain.mp3`,
    block: `${ROOT}/block/block-animation-sound.mp3`,
  },
  particles: {
    damage: [
      { url: `${ROOT}/particle/nut.png`, size: 21 },
      { url: `${ROOT}/particle/bolt.png`, size: 21 },
      { url: `${ROOT}/particle/gear1.png`, size: 25 },
      { url: `${ROOT}/particle/gear2.png`, size: 28 },
    ],
  },
  timings: {
    idle: { speed: 0.66 },
    run: { speed: 0.66 },
    punch: { speed: 1, impactFrame: 8 },
    kick: { speed: 0.75, impactFrame: 10, scale: 1.15 },
    pain: { speed: 1, impactFrame: 1, offsetY: 5, scale: 1.1 },
    painAir: { speed: 1, impactFrame: 4, offsetX: 0, offsetY: 10, scale: 1.30 },
    dodge: { speed: 1, impactFrame: 6 },
    block: { holdFrame: 16, holdDurationMs: 0 },
    victory: { speed: 0.66, holdFrame: 13, loopBackFrame: 3 },
    // Sag from stance into the slump, freeze on the final frame.
    lose: { speed: 0.66 },
    // Per-skill anim tuning. impactFrame is skill-defined: cannon = the
    // muzzle-fire frame (projectile spawns), earthshake = the slam frame
    // (screen shake + ball drops fire). speed / offsetX / offsetY behave like
    // the base slots above.
    // scale: bump >1 when the sheet has a big prop (earthshake's anvil) that
    // shrinks the character under the height-fit. Tune visually.
    skills: {
      cannon: { speed: 1, impactFrame: 9 },
      earthshake: { speed: 0.85, impactFrame: 12, offsetY: 15, scale: 1.18 },
      repair: { speed: 0.55, impactFrame: 8, offsetX: -1, offsetY: 0, scale: 0.985 },
      charge: { speed: 0.55, offsetX: 0, offsetY: 3.5, scale: 1.175 },
      // impactFrame = the brightest burst frame (body hidden), where the
      // teleport position snap happens.
      blink: { speed: 0.70, impactFrame: 6, offsetY: 8, scale: 1.20 }
    },
    anchorOffsetX: 0,
  },
};
